import ouiBase from '@goldwasserexchange/oui';
import { hitHdcToSignFromLine } from '../../../../shared';
import { useAccountPositionsHistoryTransformApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryHisMvtHitHdc = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountPositionsHistoryTransformApiByHisMvtId({
    hisMvtId,
    transformFunction: hitHdcToSignFromLine,
  });
  return response;
};
